import React, { Component } from 'react';
import { Auth, API, graphqlOperation } from 'aws-amplify';
import { updateUser } from '../graphql/mutations';
import { Redirect } from 'react-router-dom';
import Login from './Login';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '../components/LoginSignupTextfield';
import './LoginSignup.css';

import { profanityEN, profanityENEquals, profanitySE } from '../data/Profanity'
import CircularProgress from "@material-ui/core/CircularProgress";

class SignUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: "",
            username: "",
            email: "",
            birthday: "YYYY-MM-DD",
            userID: "",
            verification: false,
            confirmationCode: 0,
            successfulCreation: false,
            birthdayPicker: false,
            avatarPicker: false,
            verificationCode: false,
            switchToLogIn: false,
            agreeToTerms: false,
            usernameError: "",
            passwordError: "",
            emailError: "",
            hasAgreedToTerms: false,
            hasAgreedToPrivacy: false


        }

    }

    handleInputChange = (event) => {

        var newState = {};
        newState[event.target.id] = event.target.value;
        this.setState(newState)
    }

    handleConfirmationChange = (event) => {
        this.setState({
            confirmationCode: event.target.value
        })

    }

    isAlphaNumeric = (character) => {
        return (/^[a-z0-9]+$/i.test(character))
    }

    isNumeric = character => {
        return (/^(0|[1-9][0-9]*)$/i.test(character))
    }

    isPasswordSpecialCharacter = (character) => {
        let special_chars = "~!@#$%^&*_-+=`|(){}[]:;'<>,.?/\\"
        return (special_chars.includes(character))
    }

    isUsernameSpecialCharacter = (character) => {

        let allowed_chars = "_."
        return (allowed_chars.includes(character))
    }

    setPasswordError = (error) => {
        this.setState({
            passwordError: error

        })
    }

    setUsernameError = (error) => {
        this.setState({
            usernameError: error
        })
    }

    switchToLogIn = () => {
        this.setState({
            switchToLogIn: true
        })
    }

    hanldeCreteAccount = async () => {
        let inputValidation = await this.inputValidation()
        if (inputValidation) {
            this.setState({
                birthdayPicker: true
            })

        }
    }

    confirmBirthday = () => {
        if (this.state.birthday === "YYYY-MM-DD") {
            this.setState({
                birthdayError: "Please choose a date first"
            })

        }
        else {
            this.setState({
                verification: true
            })

        }

    }

    handleBirthdayChange = (event) => {

        this.setState({
            birthday: event.target.value
        })
    }

    handleEmailChange = (event) => {
        this.setState({
            email: event.target.value
        })
    }

    handleActivationCodeChange = (event) => {
        this.setState({
            confirmationCode: event.target.value
        })
    }

    openPrivacyPolicy = () => {
        window.open("https://imagilabs.com/policies/privacy-policy")
    }

    openTermsConditions = () => {
        window.open("https://imagilabs.com/pages/terms-of-use")
    }

    handleCheckPrivacy = () => {
        this.setState({
            hasAgreedToPrivacy: !this.state.hasAgreedToPrivacy
        })

    }

    handleCheckTerms = () => {
        this.setState({
            hasAgreedToTerms: !this.state.hasAgreedToTerms
        })

    }

    allDone = () => {
        this.setState({
            successfulCreation: true
        })
    }


    usernameNotTaken = async () => {

        try {

            console.log(this.state.username)
            let stuff = await Auth.signUp({
                username: this.state.username,
                password: "dummyrino1",
                attributes: {
                    email: "dummy@dum.dum"
                }
            })

            console.log("true", stuff)
            return true

        }
        catch (e) {
            console.log(e)
            if (e.message.includes("Username check")) {
                return true
            }
            else {
                return false

            }


        }

    }

    usernameIncludesProfanity = () => {
        //EN-checking for words that are not allowed as standing alone
        if (profanityENEquals.includes(this.state.username)) {
            return true

        }
        //EN-checking for words that are not allowed as part of a word or standing alone 
        if (profanityEN.includes(this.state.username)) {
            return true
        }
        for (let i = 0; i < profanityEN.length; i++) {
            if(this.state.username.includes(profanityEN[i])){
                return true
            }
        }
        //SE-checking for words that are not allowed as part of a word or standing alone
        if (profanitySE.includes(this.state.username)) {
            return true
        }
        for (let i = 0; i < profanitySE.length; i++) {
            if(this.state.username.includes(profanitySE[i])){
                return true
            }
        }

    }



    passwordValidation = () => {

        let special_char_count = 0
        let error = ""

        if (this.state.password === this.state.username.toLowerCase()) {
            error = "Password cannot be indentical to username"
            this.setPasswordError(error)
            return false
        }

        else if (this.state.password.length >= 8 && this.state.password.length <= 40) {
            for (let i = 0; i < this.state.password.length; i++) {
                if (this.isPasswordSpecialCharacter(this.state.password[i]) || (this.isNumeric(this.state.password[i]))) {
                    special_char_count++
                }
                else if (!this.isAlphaNumeric(this.state.password[i]) && !this.isPasswordSpecialCharacter(this.state.password[i])) {
                    error = "There is a not allowed character in the password"
                    this.setPasswordError(error)
                    return false
                }
            }

            if (special_char_count === 0) {
                error = "Password must include a letter or a special character"
                this.setPasswordError(error)

                return false
            }

            error = ""
            this.setPasswordError(error)

            return true
        }
        else {
            error = "Password has to be 8-40 characters long"
            this.setPasswordError(error)


            return false
        }

    }

    usernameValidation = async () => {

        let error = ""

        if (this.state.username.length >= 3 && this.state.username.length <= 20) {


            for (let i = 0; i < this.state.username.length; i++) {
                if (!this.isAlphaNumeric(this.state.username[i]) && !this.isUsernameSpecialCharacter(this.state.username[i])) {
                    error = "There is a not allowed character in the username"
                    this.setUsernameError(error)
                    return false
                }

            }

            if (this.usernameIncludesProfanity()) {
                error = "Profanity is not allowed"
                this.setUsernameError(error)
                return false

            }
            else {
                //checking if the validly written username exists 
                let usernameNotTaken = await this.usernameNotTaken()
                if (usernameNotTaken) {
                    error = ""
                    this.setUsernameError(error)
                    return true

                }
                else {
                    error = "This username is already taken. Please think of another one."
                    this.setUsernameError(error)
                    return false
                }


            }



        }

        else {
            error = "Username has to be 3-20 characters long"
            this.setUsernameError(error)
            return false
        }

    }

    inputValidation = async () => {

        let valid_username = await this.usernameValidation()
        let valid_password = this.passwordValidation()
        return (valid_password && valid_username)

    }


    SignUp = async () => {

        if (this.state.email !== "") {
            try {
                const newUser = await Auth.signUp({
                    password: this.state.password,
                    username: this.state.username.toLowerCase(),
                    attributes: {
                        email: this.state.email,

                    }
                });
                this.setState({
                    verificationCode: true,
                    userID: newUser.userSub

                })

            } catch (e) {
                this.setState({
                    emailError: "Email address already in use"
                })
                console.log('Error: ', e)
            }
        }
        else {
            this.setState({
                emailError: "Please provide an email"
            })
        }


    }

    confirmSignUp = async () => {
        this.setState({
            codeError: "",
            loading: true
        })

        if (this.state.confirmationCode.length === 6) {
            try {
                await Auth.confirmSignUp(this.state.username.toLowerCase(), this.state.confirmationCode);
                await Auth.signIn(this.state.username.toLowerCase(), this.state.password)
                await this.userAttributeAddition()
                this.setState({
                    agreeToTerms: true
                })
            } catch (error) {
                console.log('error confirming account', error);
                this.setState({
                    codeError: "Incorrect verification code",
                    loading:false
                })
            }
        }
        else {
            this.setState({
                codeError: "Please enter a 6 digit code"
            })
        }

    }



    resendConfirmationCode = async () => {
        try {
            await Auth.resendSignUp(this.state.username);
            alert("Please check if you received the code and enter it again.🤞 If you are still having an issue you can report it.")
        }
        catch (error) {
            console.log("error resending code", error)
        }

    }


    //adding additional chosen attributes to the backend user - birthday + avatar
    userAttributeAddition = async () => {

        let user_data = { id: this.state.userID, dateOfBirth: this.state.birthday, avatarName: "matrixLightning" }

        let mut = await API.graphql(graphqlOperation(updateUser, { input: user_data }))

        console.log("done", mut)


    }



    displayStep = () => {

        if (this.state.switchToLogIn) {
            return (<Login />)

        }

        else if (this.state.successfulCreation) {
            return (<Redirect to="/app/explore"></Redirect>)

        }

        else if (this.state.agreeToTerms) {
            return (
                <>
                    <h1>CREATE ACCOUNT</h1>
                    <p>Great job, {this.state.username}.</p>
                    <p>We have one final request from you as your privacy is important for us. </p>
                    <div style={{ display: "flex" }}>
                        <Checkbox onClick={this.handleCheckTerms} color="primary"></Checkbox>
                        <p>I agree to imagiLabs' <span> <p style={{ color: "rgb(103, 212, 239)", textDecoration: "underline" }} onClick={this.openTermsConditions}>terms and conditions</p></span></p>
                    </div>
                    <div style={{ display: "flex" }}>
                        <Checkbox onClick={this.handleCheckPrivacy} color="primary"></Checkbox>

                        <p>I agree to imagiLabs' <span> <p style={{ color: "rgb(103, 212, 239)", textDecoration: "underline" }} onClick={this.openPrivacyPolicy} >privacy policy</p></span></p>
                    </div>

                    <button style={{ width: "100%", height: "40px" }} onClick={this.allDone} disabled={!(this.state.hasAgreedToTerms && this.state.hasAgreedToPrivacy)}> Start Creating </button>

                </>
            )
        }

        else if (this.state.verificationCode) {

            return (<>
                <h1>ACCOUNT ACTIVATION</h1>
                <p>Enter the received activation code</p>

                <form style={{ display: "flex", flexDirection: "column", marginBottom: "3%" }}>
                    <TextField onChange={this.handleActivationCodeChange} margin="normal" id="confirmation" label="Activation code" />

                    <p style={{ margin: "0px", fontSize: "12px", color: "#FF857E" }}>{this.state.codeError}</p>
                </form>

                <p
                    onClick={this.resendConfirmationCode}
                    style={{ textDecoration: "underline", color: "rgb(103, 212, 239)", cursor: "pointer" }}>
                    I did not receive my code. Resend it.</p>

                    {this.state.loading ?
                        <div>
                            <CircularProgress></CircularProgress>
                        </div>
                        :
                        <button style={{ width: "100%", height: "40px" }} onClick={this.confirmSignUp}>Confirm</button>


                    }




            </>
            )

        }

        else if (this.state.verification) {
            return (<>
                <h1>ACCOUNT ACTIVATION</h1>
                <br></br>
                <p>Enter your email address to receive an activation code</p>

                <form id="email" style={{ display: "flex", flexDirection: "column", marginBottom: "3%" }}>

                    <TextField onChange={this.handleEmailChange} margin="normal" id="email" label="Email" />
                    <p style={{ margin: "0px", fontSize: "12px", color: "#FF857E" }}>{this.state.emailError}</p>


                </form>

                <button style={{ width: "100%", height: "40px" }} onClick={this.SignUp}>Send activation code</button>



            </>
            )
        }
        else if (this.state.birthdayPicker) {
            return (
                <>
                    <h1>CREATE ACCOUNT</h1>
                    <p>When is your birthday?</p>

                    <form style={{ display: "flex", flexDirection: "column", marginBottom: "3%" }}>

                        <TextField onChange={this.handleBirthdayChange} margin="normal" id="birthday" type="date" />
                        <p style={{ margin: "0px", fontSize: "12px", color: "#FF857E" }}>{this.state.birthdayError}</p>


                    </form>

                    <button style={{ width: "100%", height: "40px" }} onClick={this.confirmBirthday}>Confirm birthday</button>

                </>
            )
        }
        else {

            return (
                <>
                    <h1>CREATE ACCOUNT</h1>
                    <form onChange={this.handleInputChange} style={{ display: "flex", flexDirection: "column" }} >

                        <TextField margin="normal" id="username" label="Username" value={this.state.username.toLowerCase()} />
                        <p style={{ margin: "0px", fontSize: "12px", color: "#FF857E" }}>{this.state.usernameError}</p>

                        <TextField margin="normal" id="password" label="Password" type="password" />
                        <p style={{ margin: "0px", fontSize: "12px", color: "#FF857E" }}>{this.state.passwordError}</p>


                    </form>



                    <p>Already have an account? <span > <button onClick={this.switchToLogIn} style={{ marginTop: "8%", outline: "none", textDecoration: "underline", background: 'none', border: "none", color: "rgb(103, 212, 239)", fontSize: "16px" }}> Log In</button>  </span> </p>

                    <button style={{ width: "100%", height: "40px" }} onClick={this.hanldeCreteAccount}>Create Account</button>
                </>)

        }
    }



    render() {
        return (
            <div style={{ textAlign: "center", color: "white", display: "flex", alignContent: "center", flexDirection: "column" }}>


                {this.displayStep()}

            </div>

        )
    }
}
export default SignUp;